import { call, put, select, takeLatest } from 'redux-saga/effects';

import API from 'services/api';

import { fetchProfile } from 'store/session/actions';
import { getGroupId } from 'store/session/selectors';

import { types, updateCompanyName } from './actions';

export default function* root() {
  yield takeLatest(types.UPDATE_BUSINESS_NAME_REQUEST, watchUpdateBusinessName);
}

function* watchUpdateBusinessName(action) {
  const { businessName } = action.payload;
  try {
    const groupId = yield select(getGroupId);
    yield call(API.groups.updateUserGroup, groupId, { businessName });
    yield put(fetchProfile.request());
    yield put(updateCompanyName.success());
  } catch (e) {
    yield put(updateCompanyName.error(e));
  }
}
